module.exports = __webpack_public_path__ + "img/accesoires-huitres-en-ligne-boutrais-medium.17a130f6.png";